import { render, staticRenderFns } from "./DecisionOnLeaveToAppealRspToLeavePg.vue?vue&type=template&id=c1e984a2&scoped=true"
import script from "./DecisionOnLeaveToAppealRspToLeavePg.vue?vue&type=script&lang=ts"
export * from "./DecisionOnLeaveToAppealRspToLeavePg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e984a2",
  null
  
)

export default component.exports